'use strict';

var Cleave = require('cleave.js/dist/cleave.js');

var util = require('../components/util');
var validator = require('../components/validator');
var formPrepare = require('../components/formPrepare');
var address = require('../components/address');
var facilemodal = require('../components/facile-modal');
var inputs = require('../components/inputs');
var ccTypePattern = require('../components/cc-type-pattern');
var signupProcess = require('../components/signup-process');
var marketingPreferences = require('../components/marketingpreferences');
var passwordVisibilityToggle = require('../components/passwordvisibilitytoggle');
var addressSuggest = require('../components/address-suggest');

var _siteID;
var _postalMasks;
var _shipToCountry;

var $address1;
var $address2;
var $zip;
var $city;
var $country;
var $state;

/**
 * @private
 * @function
 * @description Password Reset
 */

// ON CHECKOUT SIGNIN AND ACCOUNT LOGIN PAGE
var passwordReset = function () {

	var $passwordResetForm = $("#PasswordResetForm");
	var _action = $passwordResetForm.data("action");
	var array = $passwordResetForm.serializeArray();
	var _data = {};
	$.each(array, function () {
		_data[this.name] = this.value || "";
	});
	var $email = $("input.resetemail");
	if ($email.valid()) {
		$.ajax({
			type: "POST",
			url: _action,
			data: _data,
			success: function (data) {
				$(".password-reset").hide();
				$("#confirmationcontainer").show();
			},
			error: function () {
				$(".password-reset").hide();
				$("#confirmationcontainer").hide();
				$(".password-reset-500error").show();
			}
		});
	}
};

/**
 * @private
 * @function initAddressForm
 * @description
 */
var initAddressForm = function () {

	inputs.init();
	validator.init();
	formPrepare.init({
		continueSelector: 'button.apply',
		formSelector: '[id$="EditAddressForm"]'
	});

	var $addressbox = $(".account-addresses");

	$address1 = $("input[name$='_address1']");
	$address2 = $("input[name$='_address2']");
	$zip = $("input[name$='_zip']");
	$city = $("input[name$='_city']");
	$country = $("select[name$='_country']");
	$state = $("select[name$='_states_state']");

	_siteID = $addressbox.data("siteid");
	_postalMasks = $addressbox.data("postalmasking");
	_shipToCountry = $addressbox.data("shiptocountry");

	if (_siteID == "US" || _siteID == "CA") {
		$(".phone").mask('000-000-0000');
	}

	var selectedCountry = $country.val() || _shipToCountry;
	if (selectedCountry != 'GB') {
		$(".country").val(selectedCountry);
	}
	// update state label upon entering page
	var _stateProvince = $("#EditAddressForm").data("stateprovince");
	address.updateState(selectedCountry, _stateProvince);

	address.changePostalCode(selectedCountry, _postalMasks);

	if (_postalMasks != null && _postalMasks.length > 0) {
		address.changePostalMask(selectedCountry, _postalMasks);
	}

	if ($address1.hasClass("googleautocomplete")) {
		initGoogleAutocomplete();
	}

};

/**
 * @function initGoogleAutocomplete
 * @description Initialize Google address suggestions
 */
var initGoogleAutocomplete = function () {
	var $addressbox = $(".account-addresses");
	addressSuggest.init({
		shipToCountry: $addressbox.data("shiptocountry"),
		address1: $address1,
		address2: $address2,
		city: $city,
		postalCode: $zip,
		state: $state,
		country: $country,
		onSelection: () => {
			// Run validation on all address fields, except [phone]
			[$state, $zip, $city, $address2, $address1].forEach(function ($this) {
				$this.focus().blur();
				util.checkInputVal($this);
			});
		}
	});
};

/**
 * @private
 * @function initCreditCardForm
 * @description
 */
var initCreditCardForm = function () {
	inputs.init();
	validator.init();

	var $ccType = $("select[name$='paymentinstruments_creditcards_newcreditcard_type']");
	var $ccNo = $("input[name*='paymentinstruments_creditcards_newcreditcard_number']");

	// init credit card form for pattern matching and card type check
	ccTypePattern.init($ccNo, $ccType);

	var $ccMonth = $("input[name$='paymentinstruments_creditcards_newcreditcard_month']");
	var $ccYear = $("input[name$='paymentinstruments_creditcards_newcreditcard_year']");

	new Cleave("input[name$='paymentinstruments_creditcards_newcreditcard_monthAndYear']", {
		date: true,
		datePattern: ['m', 'y'],
		onValueChanged: function (e) {
			var rawValue = e.target.rawValue;
			if (rawValue.length == 4) {
				$ccMonth.val(Number(rawValue.substring(0, 2)));
				$ccYear.val(Number('20' + rawValue.substring(2)));
			}
		}
	});

	formPrepare.init({
		continueSelector: 'button.apply',
		formSelector: '[id$="CreditCardForm"]'
	});
};

/**
 * @private
 * @function
 * @description init events for the loginPage
 */
var initializeDOM = function (el) {

	$(window).resize(function () {
		$('.myaccount-banner-box img').each(function () {
			if ($(this).is(":visible")) {
				$(this).attr("src", $(this).data("source"));
			}
		});
	});

	// EDIT PROFILE PAGE
	if ($(".profile").length > 0) {

		if ($(".success-msg").length > 0) {
			setTimeout(function () {
				$(".success-msg").fadeOut(1000);
			}, 5000);
		}

		if ($(".change-password .error-msg").length > 0 || $(".change-password .success-msg").length > 0) {
			$('html, body').animate({
				scrollTop: $(".change-password").offset().top
			}, 2000);
		}

		passwordVisibilityToggle.init($accountNewPassword);
	}

	// Direct signup page
	initDirectSignupPage();

	// Make sure password fields are blank at all times upon page load for setting a new password form.
	var $accountNewPassword = $(".account-newpassword");
	if ($accountNewPassword.length > 0) {
		$accountNewPassword.find(".value input").val("");
		passwordVisibilityToggle.init($accountNewPassword);
	}

	// Order Details Invoice Tabbing
	$('#order-invoice-section').tabs();

	// avoid submitting the sign in button more than once. This only checks for login in /account page. It won't check on modal windows.
	var $signinForm = $(".pt_account .signin-form");
	var $signinBtn = $signinForm.find(".btn");
	$signinForm.submit(function (e) {
		// Check if the form has been submitted
		if ( $signinBtn.attr('attempted') == 'true' ) {
		// stop submitting the form if submit has already been submitted.
			e.preventDefault();
		} else if ($signinForm.valid()) {
			$signinBtn.attr("attempted", 'true');
		}
	});
	// Update the button state on captcha events.
	$signinForm.on('icebreaker:reCaptcha', (event, data) => {
		$signinBtn.attr('disabled', data.expired || !data.verified);
	});

	// LOGIN / REGISTRATION PAGE
	var $loginRegisterBox = $('.login-register-box', el);
	if ($loginRegisterBox && $loginRegisterBox.length) {
		$loginRegisterBox.tabs({active: $loginRegisterBox.data('tab-active')});
		passwordVisibilityToggle.init($loginRegisterBox);
	}

	// LOYALTY LOGIN / REGISTRATION PAGE
	var $loginLoyalty = $('.join-rewards-panel', el);
	if ($loginLoyalty && $loginLoyalty.length) {
		passwordVisibilityToggle.init($loginLoyalty);
	}
};

/**
 * Initializes the direct signup page, which a customer who did
 * retail signup will be taken to from Emarsys emails.
 *
 */
var initDirectSignupPage = function () {
	// Direct signup (with retail signup)
	var $directSignupForm = $('.direct-signup');
	if ($directSignupForm && $directSignupForm.length) {

		// Check email address validity
		if (!$("input[name$='_customer_email']").valid()) {
			$directSignupForm.toggleClass('has-invalid-email', true);
		}

		// Listen for focus event on the primary password field, reveal the
		// secondary password field and the submit button upon focus in.
		var passwordFields = $directSignupForm.find("input[type=password]");
		passwordFields.on("focus", function () {
			$directSignupForm.toggleClass('show-secondary-section', true);
			passwordFields.off("focus");
		});
	}
};

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
var initializeEvents = function () {

	// Open return label pdf
	$(".pt_account .label-download").on("click", "button.open-pdf-file", function (e) {
		e.preventDefault();
		const base64Str = $(this).data("attachment-content");
		const type = $(this).data("attachment-type");
		if (base64Str && type) {
			util.openBase64Document(base64Str, type);
		}
	});

	// Password Resets
	$(".password-reset-page").on("click", ".reset-email-btn", function (e) {
		e.preventDefault();
		passwordReset();

		var $form = $(this).closest("form");

		if ($form && $form.valid()) {

			if ($("[name$='" + $form.data("action") + "']").length == 0) {
				$form.append("<input name='" + $form.data("action") + "' value='create' type='hidden' />");
			}

			$form.submit();
		}
	});

	// ADD/EDIT ADDRESS PAGE
	if ($(".address-list").length > 0) {

		// update state label upon country selection
		// and update google suggest to supported countries or disable if not.
		$(".pt_account").on("change", ".country", function () {

			formPrepare.resetForm();

			var countryCode = $(this).val();
			address.updateState(countryCode, "");

			address.changePostalCode(countryCode, _postalMasks);

			if (countryCode == "US" || countryCode == "CA") {
				$('.textinput.phone').mask('000-000-0000');
			} else {
				$('.textinput.phone').unmask();
			}

			if ($address1.hasClass("googleautocomplete")) {
				if ( countryCode == "AU" || countryCode == "NZ" ) {
					addressSuggest.setCountry(countryCode);
					addressSuggest.enable();
				} else {
					addressSuggest.disable();
				}
			}

		});

		$(".pt_account").on("click", "button.create-address", function (e) {
			e.preventDefault();

			var CB = {
				call: function () {
					initAddressForm();
				}
			};

			facilemodal.showModal("#EditAddressModal", Urls.addAddress, null, null, null, null, null, CB);
		});

		$(".pt_account").on("click", "#EditAddressForm .apply", function (e) {
			e.preventDefault();

			formPrepare.validateGenericForm();

			var $form = $(this).closest("form");

			submitForm($form);
		});

		var pendingTimeout;
		var submitForm = function ($form) {
			var isValid = $form.valid();
			var isPending = $form.validate().pendingRequest !== 0;

			if (isPending) {
				if (typeof pendingTimeout !== "undefined") {
					clearTimeout(pendingTimeout);
				}
				pendingTimeout = setTimeout(submitForm, 50, $form);
			}

			if (!isValid || isPending) {
				return;
			}

			if ($("[name$='" + $form.data("action") + "']").length == 0) {
				$form.append("<input name='" + $form.data("action") + "' value='create' type='hidden' />");
			}
			var _continueURL = $form.attr("action");
			var _data = $form.serialize();

			var _req = $.ajax({
				type: "POST",
				url: _continueURL,
				data: _data,
				dataType: "html"
			});

			_req.done(function (html) {
				var $container = $form.closest(".fm.modal");
				$container.empty().html(html);

				// Re-initialize the address form.
				initAddressForm();

				if ($container.find(".response").length > 0) {
					facilemodal.closeFmModal();
					window.location = Urls.addressesList;
				}
			});
		};

		$(".pt_account").on("click", ".select-default", function (e) {
			e.preventDefault();
			var _actionURL = $(this).data("action");
			window.location.href = _actionURL;
		});

		$(".pt_account").on("click", ".edit-address", function (e) {
			e.preventDefault();

			var _actionURL = $(this).attr("href");

			var CB = {
				call: function () {
					initAddressForm();
				}
			};

			facilemodal.showModal("#EditAddressModal", _actionURL, null, null, null, null, null, CB);
		});

		$('.pt_account').on("click", ".delete-address", function (e) {
			e.preventDefault();

			var _actionURL = $(this).attr("href");
			window.location.href = _actionURL;
		});

	}

	// ADD/EDIT CREDIT CARDS
	if ($(".account-paymentinstruments").length > 0) {

		$(".pt_account").on("click", "button.create-creditcard", function (e) {
			e.preventDefault();

			var CB = {
				call: function () {
					initCreditCardForm();
				}
			};

			facilemodal.showModal("#AddCreditCardModal", Urls.addPaymentInstrument, null, null, null, null, null, CB);
		});

		$(".pt_account").on("click", "#CreditCardForm .apply", function (e) {
			e.preventDefault();

			// clear all space before submit the card number
			var $ccNo = $(".ccnumber");
			$ccNo.val($ccNo.val().replace(/ /g, ''));

			formPrepare.validateGenericForm();

			var $form = $(this).closest("form");

			if ($form && $form.valid()) {

				if ($("[name$='" + $form.data("action") + "']").length == 0) {
					$form.append("<input name='" + $form.data("action") + "' value='create' type='hidden' />");
				}

				var _continueURL = $form.attr("action");
				var _data = $form.serialize();

				var _req = $.ajax({
					type: "POST",
					url: _continueURL,
					data: _data,
					dataType: "html"
				});

				_req.done(function (html) {
					var $container = $form.closest(".fm.modal");
					$container.empty().html(html);

					if ($container.find(".response").length > 0) {
						facilemodal.closeFmModal();
						window.location = Urls.paymentsList;
					}
				});
			}

		});

		$('.pt_account').on("click", ".delete-card", function (e) {
			e.preventDefault();

			var $form = $(this).closest("form");

			if ($("[name$='" + $form.data("action") + "']").length == 0) {
				$form.append("<input name='" + $form.data("action") + "' value='remove' type='hidden' />");
			}

			if ($form) {
				$form.submit();
			}
		});

	}

};

const pageEntry = {
	init: function () {
		initializeDOM();
		initializeEvents();

		signupProcess.init();
		marketingPreferences.init();
	}
};

if (!window.appPages) {
	window.appPages = {};
}

window.appPages.account = pageEntry;
